<template>
  <div>
    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @click:outside="close"
      @keydown.esc="close"
    >
      <v-card>
        <v-progress-linear
          :active="isDialogVisible"
          :indeterminate="isDialogVisible"
          absolute
          top
          color="primary"
        ></v-progress-linear>
        <v-card-title>
          <span class="headline">Modifier {{ apiProduct.label }}</span>
        </v-card-title>
        <v-alert
          v-model="isAlertVisible"
          color="error"
          text
          transition="slide-y-transition"
        >
          {{ message }}
        </v-alert>
        <v-form
          ref="form"
          @submit.prevent="submitForm"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    v-model="apiProduct.key1"
                    :append-icon="isKeyVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                    :type="isKeyVisible ? 'text' : 'password'"
                    label="Key 1"
                    :rules="[rules.key1]"
                    @click:append="isKeyVisible = !isKeyVisible"
                  ></v-text-field>
                  <v-text-field
                    v-model="apiProduct.key2"
                    :append-icon="isKeyVisible2 ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                    :type="isKeyVisible2 ? 'text' : 'password'"
                    label="Key 2"
                    :rules="[rules.key2]"
                    @click:append="isKeyVisible2 = !isKeyVisible2"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="close"
            >
              Annuler
            </v-btn>
            <v-btn
              :disabled="isDialogVisible"
              :loading="isDialogVisible"
              color="success"
              type="submit"
            >
              Modifier
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, ref } from '@vue/composition-api'
import { mdiCalendar, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { mapState } from 'vuex'
import store from '@/store'
import router from '@/router'
import apiProduct from '@/store/modules/apiProduct'

export default {
  name: 'ApiKeyFormDialog',

  emits: ['clickout', 'submitted'],

  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-type-constructor
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('apiProduct', ['apiProduct']),
  },

  setup() {
    const isKeyVisible = ref(false)
    const isKeyVisible2 = ref(false)
    const date = ref(null)
    const menu = ref(false)
    const picker = ref(null)
    const menuref = ref(null)
    const form = ref(null)
    const message = ref('')
    const isDialogVisible = ref(false)
    const errors = ref('')
    const isAlertVisible = ref(false)
    const rules = {
      key1: true,
      key2: true,
    }
    const instance = getCurrentInstance()

    const close = () => {
      store.dispatch('apiProduct/hideKey', store.state.apiProduct.apiProduct.id).catch(error => {
        console.log(error)
      })
      isAlertVisible.value = false
      message.value = ''
      Object.keys(rules).forEach(key => {
        rules[key] = true
      })
      instance.emit('clickout')
    }

    const submitForm = () => {
      isAlertVisible.value = false
      isDialogVisible.value = true
      instance.emit('submitted')
      store.dispatch('apiProduct/updateKey', store.state.apiProduct.apiProduct).then(() => {
        isDialogVisible.value = false
        close()
      }).catch(error => {
        form.value.validate()
        message.value = error.response.data.message
        errors.value = error.response.data.errors
        if (error.response.data.errors !== undefined) {
          rules.key1 = error.response.data.errors.key1 !== undefined ? error.response.data.errors.key1[0] : true
          rules.key2 = error.response.data.errors.key2 !== undefined ? error.response.data.errors.key2[0] : true
        }
        isDialogVisible.value = false
        isAlertVisible.value = true
      })
      instance.emit('submitted')
    }

    return {
      isKeyVisible,
      isKeyVisible2,
      isAlertVisible,
      isDialogVisible,
      message,
      rules,
      submitForm,
      form,
      date,
      menu,
      picker,
      menuref,
      close,

      // icons
      icons: {
        mdiCalendar, mdiEyeOutline, mdiEyeOffOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
